import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-grids';
import { Observable, Subject } from 'rxjs';
import {  map } from 'rxjs/operators';
import { GlobalComponent } from 'src/app/global/global.component';
@Injectable({
  providedIn: 'root'
})
export class ClientEmployeeDynamicFormListService extends Subject<DataStateChangeEventArgs>{
  constructor(private http: HttpClient,public global : GlobalComponent) {
    super();
  }
  // ClientForm
  public outputValuesClientForm(DynamicFormClientState): void {
    this.getDynamicFormClientList(DynamicFormClientState).subscribe(DFCS => super.next(DFCS));
  }
  getDynamicFormClientList(DynamicFormClientState): Observable<DataStateChangeEventArgs> {
    let url;
    if(this.global.OnboardingLoginType =='onboardLogin')
      {
        url = "api/Client_DynamicForms/getDynamicClientFormList";
     }
     else{

        url = "api/DynamicClientForm/getDynamicClientFormList";
     }
    return this.http.post<any>(url, DynamicFormClientState)
      .pipe(map(
        (response: any) => (<any>{

          result: response['result'],
          count: response['count'],
          ids: response['ids'],
        })))
      .pipe(map((e: any) => {
       
        e.result.forEach(element => {
        })
        return e;
      })
      )
  }
   // Employee Form
  public outputValuesEmployeeForm(url,DynamicFormEmployeeState): void {
    
    this.getDynamicEmployeeFormList(url,DynamicFormEmployeeState).subscribe(DFCS => super.next(DFCS));
  }
  getDynamicEmployeeFormList(url,DynamicFormEmployeeState): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>(url, DynamicFormEmployeeState)
      .pipe(map(
        (response: any) => (<any>{
          result: response['result'],
          count: response['count'],
          ids: response['ids'],
        })))
      .pipe(map((e: any) => {
      
       
        e.result.forEach(element => {
        })
        return e;
      })
      )
  }
  
}

